exports.ValueBox = require('./ValueBox').default
exports.TextBox = require('./TextBox').default
exports.GenderBox = require('./GenderBox').default
exports.Calculator = require('./Calculator').default


// WEBPACK FOOTER //
// ./src/components/index.js